import { Round } from '../models/round';
import { RecentRound } from '../models/recent-round';

class RecentRoundsService {
    public getRecentRounds() {
        const data = localStorage.getItem('recentRounds');
        if (!data) return [];
        return JSON.parse(data) as RecentRound[];
    };

    public updateRecentRounds(roundId: string, roundName: string, playerId: string, playerName: string) {
        const recentRound = {
            roundId,
            roundName,
            playerId,
            playerName
        }
        const existing = this.getRecentRounds();
        const filtered = existing.filter(r => r.roundId !== roundId);
        const updated = [recentRound, ...filtered].slice(0, 10);
        localStorage.setItem('recentRounds', JSON.stringify(updated));
    };
}

export const recentRoundsService = new RecentRoundsService();